import { render, staticRenderFns } from "./Testversion.vue?vue&type=template&id=474bb1f1&scoped=true&"
import script from "./Testversion.vue?vue&type=script&lang=js&"
export * from "./Testversion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474bb1f1",
  null
  
)

export default component.exports